import React from "react";

import { ID } from "common/entities/IEntity";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty, toArray } from "core/util/ArrayUtils";
import { nDef } from "core/util/TypeUtils";
import { TagSetsComponent } from "./components/TagSetsComponent";
import { TagSetsComponentConfig } from "./components/TagSetsComponentConfig";
import BundleTag from "./entities/BundleTag";
import BundleTagParams from "./params/BundleTagParams";
import labelProvider from "./RefineBundleTag.labels";
import RefineBundleTagConfig from "./RefineBundleTagPanelConfig";

const ManyBundleTags = Query.queryMany<BundleTag, BundleTagParams>(BundleTag);
const { Labels } = labelProvider;
const PARAM_TAGS = "tagIds";

@Panel({
	id: "refine-bundle-tag",
	configClass: RefineBundleTagConfig,
	pageParams: true,
	labelProvider,
})
export class RefineBundleTag extends React.PureComponent<
	IPanelProps<RefineBundleTagConfig>
> {
	public render() {
		const { config, pageParams } = this.props;

		const params = !isEmpty(config.tagSetIds)
			? { tagSetIds: config.tagSetIds }
			: {};

		return (
			<ManyBundleTags params={params}>
				{({ data, loading }) => {
					if (loading) {
						return <Loading />;
					}

					if (isEmpty(data)) {
						return (
							<NonIdealState
								title={<Labels.TagsEmpty />}
								description={<Labels.TagsEmptyDescription />}
							/>
						);
					}

					const tagSets = toArray(
						data.reduce((acc, tag) => {
							nDef(acc[tag.tagSet.id], () => {
								acc[tag.tagSet.id] = {
									...tag.tagSet,
									tags: [],
								};
							});
							acc[tag.tagSet.id].tags.push(tag);
							return acc;
						}, {})
					);

					if (tagSets && tagSets.length) {
						tagSets.sort((a, b) =>
							a.sortIndex > b.sortIndex
								? 1
								: b.sortIndex > a.sortIndex
								? -1
								: 0
						);
					}

					const value = pageParams[PARAM_TAGS];

					return (
						<TagSetsComponent
							config={
								config.tagSetsConfig ||
								new TagSetsComponentConfig()
							}
							data={tagSets}
							onChange={this.onTagChange}
							value={value ? value.split(",") : undefined}
						/>
					);
				}}
			</ManyBundleTags>
		);
	}

	private onTagChange = (ids: ID[]) => {
		if (isEmpty(ids)) {
			this.props.actions.removePageParams([PARAM_TAGS, "pageSize"]);
		} else {
			this.props.actions.pushPageParams(
				{ key: PARAM_TAGS, value: ids.toString() },
				{ key: "pageNumber", value: 0 }
			);
		}
	};
}



// WEBPACK FOOTER //
// ./src/panels/refineTag/RefineBundleTag.panel.tsx